import { Component, Output, EventEmitter, Input } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { LoadingController, ToastController } from '@ionic/angular';
import { CategoriaService } from 'src/app/shared/service/categoria/categoria.service';
import { Categoria } from 'src/app/shared/model/categoria/categoria.model';
import { Router } from '@angular/router';

@Component({
  selector: 'cmp-categorias',
  templateUrl: './categorias.component.html',
  styleUrls: ['./categorias.component.scss']
})
export class CategoriasComponent extends BaseComponent {

  categorias: Categoria[] = [];
  @Input() valor: Categoria[] = [];
  @Output() selected: EventEmitter<any> = new EventEmitter;

  selectedCategories: number[] = [];

  constructor(
    public router: Router,
    public toastController: ToastController, 
    public loadingController: LoadingController,
    protected service: CategoriaService) { 
    super(router, toastController, loadingController);
  }

  ngOnInit(): void {
      this.listar();
  }

  listar(): void {
    this.categorias = [];
    this.service.listar().then((resultado) =>{
      this.categorias = resultado.categories as Categoria[];
    });
  }

  onSelected(item: any) {
    this.selected.emit([item.id]);
    this.selectedCategories.push(item.id);
  }

  isSelected(item: any) {
    return false;
    // return this.selectedCategories.includes(item.id);
  }
}
